module.exports = __webpack_public_path__ + "img/logo-lr.ee76dfe8.png";